// Zdroj pravdy pre texty landingu — edituje sa ručne. Generátor k tomuto neexistuje.
const en = {
  "nav": {
    "download": "Download",
    "features": "Features",
    "howItWorks": "How it works",
    "forEmployees": "For employees",
    "pricing": "Pricing",
    "login": "Log in",
    "tryFree": "Try for free",
    "tryFree3": "Try 3 months free",
    "openMenu": "Open menu",
    "closeMenu": "Close menu"
  },
  "employer": {
    "title": "What you get as a company",
    "leadBefore": "Add your people, see attendance and handle requests in the",
    "leadLink": "app",
    "leadAfter": "— from your computer, no install.",
    "features": [
      {
        "title": "Who's at work — and who isn't",
        "description": "See who's working, who's on a break or off. No need to call around the whole team."
      },
      {
        "title": "Team chat and calls",
        "description": "Groups by location, calls and video right in the app. Work stays in the company, not in a private WhatsApp."
      },
      {
        "title": "Attendance and history",
        "description": "Check-ins, check-outs and breaks. Edit records and export for payroll."
      },
      {
        "title": "Workplaces and QR codes",
        "description": "A QR for the entrance or reception. Scan in the app on Android and iPhone."
      },
      {
        "title": "Requests from employees",
        "description": "A time fix or a forgotten check-out — approve or reject with one click."
      },
      {
        "title": "AI assistant over attendance",
        "description": "Ask “Who's at work today?” or “How many hours did Peter log in June?” — the answer comes from your data."
      }
    ]
  },
  "employerPeople": {
    "title": "What's in the app",
    "lead": "An overview of your people and attendance in the browser at my.effzone.com — not a chat separated from who's at work today.",
    "block1Title": "Who's at work — and who isn't",
    "block1Desc": "See who's working right now, who's on a break or off. No need to call around the whole team.",
    "block1Alt": "Effzone — overview of who's at work in the app",
    "block2Title": "Employees in a few clicks",
    "block2Desc": "Add a name and phone number. The person gets an SMS code, signs in and they're in the system."
  },
  "employerComms": {
    "title": "Requests and messages",
    "lead": "Approve attendance edits and send announcements straight to your employees' app.",
    "block1Title": "Requests from employees",
    "block1Desc": "A forgotten check-out or a time fix — they send a request in the app, and you approve or reject it.",
    "block2Title": "Messages straight to the app",
    "block2Desc": "An announcement or notification for the whole company or just a select few — no emails that nobody reads.",
    "block2Alt": "Effzone — team communication and messages"
  },
  "employerAttendance": {
    "title": "Attendance and workplaces",
    "lead": "Change history, exports and QR check-in — no terminal or special reader.",
    "block1Title": "Attendance and history",
    "block1Desc": "Check-ins, check-outs and breaks for everyone, every day. Edit records and export when you need it for payroll.",
    "block2Title": "Workplaces and QR codes",
    "block2Desc": "Create a workplace, print the QR and put it at the entrance or reception. Employees scan in the app on Android and iPhone. Optionally with location-based restriction too."
  },
  "faq": {
    "title": "Frequently asked questions",
    "items": [
      {
        "q": "What happens after the three free months?",
        "a": "Nothing automatic — we don't ask for a payment card when you sign up. We'll get in touch and agree together whether you continue."
      },
      {
        "q": "Does the app track people's location?",
        "a": "No. Location is only verified at the moment someone checks in at the workplace (if the company turns on location verification) — during the day the app doesn't track location."
      },
      {
        "q": "What if someone doesn't have a smartphone?",
        "a": "They can check in through a web browser at my.effzone.com, or an admin can add the record in the app."
      },
      {
        "q": "How do I get the data for payroll?",
        "a": "Export attendance to Excel in a few clicks and send it to your accountant just like before."
      },
      {
        "q": "Can we cancel anytime?",
        "a": "Yes — no commitment and no fee. Before cancelling, you can export your attendance to Excel."
      }
    ]
  },
  "cta": {
    "title": "Want to try it in your company?",
    "textBefore": "Create an account in the",
    "textLink": "app",
    "textAfter": " or drop us a line — we'll help you set up your workplace and add your first employees.",
    "tryFree": "Try 3 months free",
    "contact": "Get in touch"
  },
  "footer": {
    "downloadApp": "Download the app",
    "privacy": "Privacy",
    "terms": "Terms",
    "admin": "Web app"
  },
  "storeBadges": {
    "appStore": "Download on the App Store",
    "googlePlay": "Get it on Google Play"
  },
  "hero": {
    "ctaDownload": "Download the app",
    "headlineLine1": [
      "Attendance"
    ],
    "headlineLine2": [
      "and team",
      "communication"
    ],
    "headlineAccent": [
      "in",
      "one",
      "app."
    ],
    "lead": "Your employee checks in with a QR code at the entrance. You see who's at work and who's off. News, polls and chat all in one app — not scattered across WhatsApp and email, where everything gets lost after a few days.",
    "ctaPrimary": "Try 3 months free",
    "pricenote": "First 3 months free · then 1,90 € per active employee monthly · no commitment",
    "statsNote": "Figures from the Effzone database · September 2026",
    "phoneAlt": "Effzone — overview of who's at work, feed and team communication",
    "card1Title": "Check-in 07:58",
    "card1Sub": "QR scan · Bratislava warehouse",
    "card2Title": "New message",
    "card2Sub": "Morning shift · 3 reactions",
    "card3Title": "Shift ended",
    "card3Sub": "Automatically at 16:00 · Nitra store"
  },
  "stats": {
    "shifts": "shifts worked",
    "hours": "hours worked",
    "months": "months in operation"
  },
  "marquee": {
    "qrAttendance": "QR attendance",
    "locationVerify": "Location check",
    "groupChat": "Group chat",
    "callsVideo": "Calls and video",
    "aiAssistant": "AI assistant",
    "autoShiftEnd": "Automatic shift end",
    "payrollExport": "Payroll export",
    "changeRequests": "Change requests",
    "polls": "Polls",
    "companyNews": "Company news",
    "multipleWorkplaces": "Multiple workplaces",
    "statistics": "Statistics"
  },
  "howItWorks": {
    "title": "How it works",
    "steps": [
      {
        "title": "Verify your phone number",
        "descBefore": "Enter your phone number, get an SMS code and create your team in the ",
        "linkText": "app",
        "descAfter": ". It takes a few minutes."
      },
      {
        "title": "Add your employees",
        "description": "Enter a name and phone number — or upload a list from Excel. Everyone gets an SMS invite and signs in with their number."
      },
      {
        "title": "Print the QR poster",
        "description": "Hang the ready-made A4 poster with a QR code and instructions where people arrive at work."
      },
      {
        "title": "People work in the app",
        "description": "They check in, see their coworkers and company news. You see everything on the dashboard."
      }
    ]
  },
  "employeeApp": {
    "title": "What you get as an employee",
    "intro": "Download the app, sign in via SMS, and your attendance, your team and company messages are all in one place — right on your phone.",
    "highlights": [
      {
        "title": "Check in with a QR code",
        "description": "Scan the code at your workplace — no paperwork, no waiting."
      },
      {
        "title": "Attendance on your phone",
        "description": "Your shift and break history, always at hand."
      },
      {
        "title": "See who's working",
        "description": "See who's at work and who's off."
      },
      {
        "title": "Team chat and feed",
        "description": "News, polls and group chats — kept separate from private messages."
      }
    ],
    "badgesLabel": "Get the mobile app",
    "heroAlt": "Effzone — work status and company feed",
    "galleryLabel": "A look inside the mobile app",
    "gallery": [
      {
        "alt": "Effzone — attendance overview in the calendar",
        "caption": "Attendance"
      },
      {
        "alt": "Effzone — team chat",
        "caption": "Chat and calls"
      },
      {
        "alt": "Effzone — folders and projects in chat",
        "caption": "Folders and projects"
      }
    ]
  },
  "useCases": {
    "title": "Who it's a good fit for",
    "intro": "Wherever attendance and communication are still handled on paper, by email or in private chats.",
    "items": [
      {
        "title": "Companies that live on WhatsApp",
        "description": "When work messages get lost among personal chats, a single company app just makes more sense."
      },
      {
        "title": "Teams with multiple workplaces",
        "description": "A QR poster at every location and a clear view of who's working where — without paper timesheets at each site."
      },
      {
        "title": "Frequent new hires",
        "description": "The admin adds a number, the person signs in and instantly sees the team, roles and what's going on."
      },
      {
        "title": "Small and mid-sized companies",
        "description": "No heavy HR system, but you still need to know who's at work and stay on the same page as a team."
      }
    ]
  },
  "pricing": {
    "title": "Pricing",
    "badge": "First 3 months free",
    "priceUnit": "/ active employee / month",
    "included": [
      "Every feature for one price — attendance, chat, calls and an AI assistant",
      "You only pay for active employees",
      "Unlimited workplaces and QR codes",
      "No commitment and no setup fees",
      "Payroll data in a few clicks (export to Excel)"
    ],
    "cta": "Start your 3 free months",
    "note": "Prices are shown excl. VAT. You pay nothing for employees with no activity in a given month. No payment card required at sign-up."
  },
  "download": {
    "title": "Effzone on every device you use",
    "subtitle": "One account, the same data. Attendance and team chat on desktop and mobile.",
    "downloadFor": "Download for",
    "ctaAppStore": "Download on the App Store",
    "ctaGooglePlay": "Get it on Google Play",
    "mac": "macOS",
    "windows": "Windows",
    "linux": "Linux",
    "ios": "iPhone / iPad",
    "iosDevices": "iPhone and iPad",
    "android": "Android",
    "appStore": "App Store",
    "googlePlay": "Google Play",
    "appleSilicon": "Apple Silicon only (M1 and newer)",
    "universal": "Apple Silicon and Intel",
    "intel": "for Intel Macs",
    "otherMacIntel": "Have an older Intel Mac?",
    "otherMacArm": "Have an Apple Silicon Mac (M1 or newer)?",
    "downloadHere": "Download",
    "sectionDesktop": "Desktop",
    "sectionMobile": "Mobile",
    "yourSystem": "Your system",
    "altDesktop": "On a different computer?",
    "altMobile": "Effzone is on desktop too —",
    "others": "Other platforms",
    "loading": "Loading versions…",
    "smartscreen": "Windows may show a SmartScreen warning on first run — the package is not signed yet. Click \u201cMore info\u201d and then \u201cRun anyway\u201d.",
    "feedError": "Could not load the downloads.",
    "retry": "Try again",
    "fact": {
      "notarized": {
        "title": "Signed and notarized by Apple",
        "text": "The macOS build is notarized, so Gatekeeper opens it without workarounds."
      },
      "selfUpdate": {
        "title": "Updates itself",
        "text": "New versions download in the background \u2014 no need to come back here."
      },
      "sameAccount": {
        "title": "The same account",
        "text": "Sign in exactly as you do in the browser; the data is identical."
      }
    }

  }
};

export default en;
